import { lazy } from 'react';
import { debugEnable } from "@/utils/utils";
import LayoutDefault from '../components/layout/LayoutDefault';
import LayoutEmpty from '../components/layout/LayoutEmpty';
import MobileLayoutDefault from '../components/layout/MobileLayoutDefault';
import MobileLayoutSubPage from '../components/layout/MobileLayoutSubPage';
import HttpError from "../components/httperror/HttpError";

// auth: 验证权限
// menu: 菜单，如果为空与auth一致
// anonymous: 默认false
// layout: 默认LayoutDefault
// exact: 是否精确匹配
// routes: 子路由
const configs = [
  // {
  //   path: "/",
  //   element: <RedirectDefault />,
  //   anonymous: true,
  //   layout: false,
  // },
  {
    path: "*",
    element: <HttpError code={404} />,
    anonymous: true,
    layout: false,
  },
  {
    path: "/401",
    element: <HttpError code={401} />,
    anonymous: true,
    layout: false,
  },
  {
    path: '/',
    component: lazy(() => import('../features/home/index')),
    anonymous: true,
    layout: LayoutEmpty,
  },
  {
    path: '/home',
    component: lazy(() => import('../features/home/index')),
    anonymous: true,
    layout: LayoutEmpty,
  },
  {
    auth: 'dashboard',
    path: '/dashboard',
    component: lazy(() => import('../features/dashboard/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'createdomesticexpressorder',
    path: '/expressorder/domestic/create',
    component: lazy(() => import('../features/expressorder/domestic/create/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'createdomesticexpressorder',
    path: '/expressorder/domestic/create/:id',
    component: lazy(() => import('../features/expressorder/domestic/create/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'updatedomesticexpressorder',
    parentmenu: 'createdomesticexpressorder',
    path: '/expressorder/domestic/edit/:id',
    component: lazy(() => import('../features/expressorder/domestic/edit/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'createinternationalexpressorder',
    path: '/expressorder/international/create',
    component: lazy(() => import('../features/expressorder/international/create/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'createinternationalexpressorder',
    path: '/expressorder/international/create/:id',
    component: lazy(() => import('../features/expressorder/international/create/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'updateinternationalexpressorder',
    parentmenu: 'createdomesticexpressorder',
    path: '/expressorder/international/edit/:id',
    component: lazy(() => import('../features/expressorder/international/edit/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'expressorderdetail',
    path: '/expressorder/detail/:id',
    component: lazy(() => import('../features/expressorder/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'expressorderreport',
    path: '/expressorder/report',
    component: lazy(() => import('../features/expressorder/report/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'expressordertodolist',
    path: '/expressorder/todo',
    component: lazy(() => import('../features/expressorder/todo/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'expressorderprocess',
    parentmenu: 'createdomesticexpressorder',
    path: '/expressorder/process/:id',
    component: lazy(() => import('../features/expressorder/process/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'print',
    path: '/waybill/toprint',
    component: lazy(() => import('../features/waybill/toprint/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'waybilltracking',
    path: '/waybill/tracking/:id',
    component: lazy(() => import('../features/waybill/tracking/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'jdfreightbill',
    path: '/freight/jd',
    component: lazy(() => import('../features/freight/jd/list/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'jdfreightbilldetail',
    parentmenu: 'jdfreightbill',
    path: '/freight/jd/detail/:id',
    component: lazy(() => import('../features/freight/jd/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'jdfreightbillcdetail',
    parentmenu: 'jdfreightbill',
    path: '/freight/jd/cdetail/:id',
    component: lazy(() => import('../features/freight/jd/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'sffreightbill',
    path: '/freight/sf',
    component: lazy(() => import('../features/freight/sf/list/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'sffreightbilldetail',
    parentmenu: 'sffreightbill',
    path: '/freight/sf/detail/:id',
    component: lazy(() => import('../features/freight/sf/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'sffreightbillcdetail',
    parentmenu: 'sffreightbill',
    path: '/freight/sf/cdetail/:id',
    component: lazy(() => import('../features/freight/sf/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'fedexfreightbill',
    path: '/freight/fedex',
    component: lazy(() => import('../features/freight/fedex/list/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'fedexfreightbilldetail',
    parentmenu: 'fedexfreightbill',
    path: '/freight/fedex/detail/:id',
    component: lazy(() => import('../features/freight/fedex/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'fedexfreightbillcdetail',
    parentmenu: 'fedexfreightbill',
    path: '/freight/fedex/cdetail/:id',
    component: lazy(() => import('../features/freight/fedex/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'dhlfreightbill',
    path: '/freight/dhl',
    component: lazy(() => import('../features/freight/dhl/list/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'dhlfreightbilldetail',
    parentmenu: 'dhlfreightbill',
    path: '/freight/dhl/detail/:id',
    component: lazy(() => import('../features/freight/dhl/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'dhlfreightbillcdetail',
    parentmenu: 'dhlfreightbill',
    path: '/freight/dhl/cdetail/:id',
    component: lazy(() => import('../features/freight/dhl/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'emsfreightbill',
    path: '/freight/ems',
    component: lazy(() => import('../features/freight/ems/list/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'emsfreightbilldetail',
    parentmenu: 'emsfreightbill',
    path: '/freight/ems/detail/:id',
    component: lazy(() => import('../features/freight/ems/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'emsfreightbillcdetail',
    parentmenu: 'emsfreightbill',
    path: '/freight/ems/cdetail/:id',
    component: lazy(() => import('../features/freight/ems/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'sffreightbillreport',
    path: '/freight/sf/report',
    component: lazy(() => import('../features/freight/sf/report/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'jdfreightbillreport',
    path: '/freight/jd/report',
    component: lazy(() => import('../features/freight/jd/report/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'fedexfreightbillreport',
    path: '/freight/fedex/report',
    component: lazy(() => import('../features/freight/fedex/report/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'dhlfreightbillreport',
    path: '/freight/dhl/report',
    component: lazy(() => import('../features/freight/dhl/report/index')),
    layout: LayoutDefault,
  },
    {
    auth: 'emsfreightbillreport',
    path: '/freight/ems/report',
    component: lazy(() => import('../features/freight/ems/report/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'shipmentsreport',
    path: '/shipments/report',
    component: lazy(() => import('../features/shipments/report/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'purchaserequest',
    path: '/purchaserequest/todo',
    component: lazy(() => import('../features/purchaserequest/todo/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'purchaserequestreport',
    path: '/purchaserequest/report',
    component: lazy(() => import('../features/purchaserequest/report/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'updatepurchaserequest',
    parentmenu: 'purchaserequest',
    path: '/purchaserequest/edit/:id',
    component: lazy(() => import('../features/purchaserequest/edit/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'copypurchaserequest',
    parentmenu: 'purchaserequestreport',
    path: '/purchaserequest/copy/:id',
    component: lazy(() => import('../features/purchaserequest/copy/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'changepurchaserequest',
    parentmenu: 'purchaserequestreport',
    path: '/purchaserequest/change/copy/:id',
    component: lazy(() => import('../features/purchaserequest/change/copy/index')),
    layout: LayoutDefault,
  },
    {
    auth: 'changepurchaserequest',
    parentmenu: 'purchaserequestreport',
    path: '/purchaserequest/change/edit/:id',
    component: lazy(() => import('../features/purchaserequest/change/edit/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'changepurchaserequest',
    parentmenu: 'purchaserequestreport',
    path: '/purchaserequest/change/process/:id',
    component: lazy(() => import('../features/purchaserequest/change/process/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'changepurchaserequest',
    parentmenu: 'purchaserequestreport',
    path: '/purchaserequest/change/detail/:id',
    component: lazy(() => import('../features/purchaserequest/change/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'processpurchaserequest',
    parentmenu: 'purchaserequest',
    path: '/purchaserequest/process/:id',
    component: lazy(() => import('../features/purchaserequest/process/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'purchaserequestdetail',
    parentmenu: 'purchaserequestreport',
    path: '/purchaserequest/detail/:id',
    component: lazy(() => import('../features/purchaserequest/detail/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'shipmentsreport',
    path: '/shipments/report',
    component: lazy(() => import('../features/shipments/report/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'dninfo',
    path: '/shipments/dninfo/:id',
    component: lazy(() => import('../features/shipments/dninfo')),
    layout: LayoutDefault,
  },
  {
    auth: 'shippinginfo',
    path: '/shipments/shippinginfo/:waybillid',
    component: lazy(() => import('../features/shipments/shippinginfo')),
    layout: LayoutDefault,
  },
  {
    auth: 'exportdeclarationinfo',
    path: '/shipments/exportdeclarationinfo/:deliveryNoteId',
    component: lazy(() => import('../features/shipments/exportdeclarationinfo')),
    layout: LayoutDefault,
  },
  // {
  //   auth: 'print',
  //   path: '/waybill/waybilldocument/',
  //   component: lazy(() => import('../features/waybill/toprint/waybilldocumentprint')),
  //   anonymous: true,
  //   layout: false,
  // },
  {
    auth: 'carriers',
    path: '/carriers',
    component: lazy(() => import('../features/carriers/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'carrieraccount',
    path: '/carrieraccount',
    component: lazy(() => import('../features/carrieraccount/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'paymentaccount',
    path: '/paymentaccount',
    component: lazy(() => import('../features/paymentaccount/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'freightbillaccount',
    path: '/freightbillaccount',
    component: lazy(() => import('../features/freightbillaccount/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'masterdata',
    path: '/masterdata',
    component: lazy(() => import('../features/masterdata/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'emailtemplate',
    path: '/emailtemplate',
    component: lazy(() => import('../features/emailtemplate/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'company',
    path: '/company',
    component: lazy(() => import('../features/company/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'department',
    path: '/department',
    component: lazy(() => import('../features/department/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'addressbook',
    path: '/addressbook',
    component: lazy(() => import('../features/addressbook/index')),
    layout: LayoutDefault,
  },
    {
    auth: 'delegation',
    path: '/delegation',
    component: lazy(() => import('../features/delegation/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'country',
    path: '/country',
    component: lazy(() => import('../features/country/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'state',
    path: '/state',
    component: lazy(() => import('../features/state/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'hscode',
    path: '/hscode',
    component: lazy(() => import('../features/hscode/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'legalunit',
    path: '/legalunit',
    component: lazy(() => import('../features/legalunit/index')),
    layout: LayoutDefault,
  },
  {
    auth: 'sparrowtemplate',
    path: '/sparrowtemplate',
    component: lazy(() => import('../features/sparrowtemplate/index')),
    layout: LayoutDefault,
  },
  {
    path: '/mobile/login',
    component: lazy(() => import('../features/mobile/login/index')),
    anonymous: true,
    layout: false,
  },
  {
    path: '/mobile/express/domestic/add',
    component: lazy(() => import('../features/mobile/express/domestic/add/index')),
    anonymous: true,
    layout: MobileLayoutDefault,
  },
  {
    path: '/mobile/express/international/add',
    component: lazy(() => import('../features/mobile/express/international/add/index')),
    anonymous: true,
    layout: MobileLayoutDefault,
  },
  {
    path: '/mobile/express/cancel/:id',
    component: lazy(() => import('../features/mobile/express/cancel/index')),
    anonymous: true,
    layout: MobileLayoutDefault,
  },
  {
    path: '/mobile/cargo/add',
    component: lazy(() => import('../features/mobile/cargo/add/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/cargo/edit',
    component: lazy(() => import('../features/mobile/cargo/edit/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/exportdeclaration/add',
    component: lazy(() => import('../features/mobile/exportdeclaration/add/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/exportdeclaration/edit',
    component: lazy(() => import('../features/mobile/exportdeclaration/edit/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/exportdeclarationitem/add',
    component: lazy(() => import('../features/mobile/exportdeclarationitem/add/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/exportdeclarationitem/edit',
    component: lazy(() => import('../features/mobile/exportdeclarationitem/edit/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/express/list',
    component: lazy(() => import('../features/mobile/express/list/index')),
    anonymous: true,
    layout: MobileLayoutDefault,
  },
  {
    path: '/mobile/express/detail/:id',
    component: lazy(() => import('../features/mobile/express/detail/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/addressbook/list/:type',
    component: lazy(() => import('../features/mobile/addressbook/list/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/addressbook/add',
    component: lazy(() => import('../features/mobile/addressbook/add/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/mobile/addressbook/edit/:id',
    component: lazy(() => import('../features/mobile/addressbook/edit/index')),
    anonymous: true,
    layout: MobileLayoutSubPage,
  },
  {
    path: '/signin',
    component: lazy(() => import('../features/auth/SignIn')),
    anonymous: true,
    layout: false,
  },
  {
    path: '/signin-internal-use-only',
    component: lazy(() => import('../features/auth/SignInTest')),
    anonymous: true,
    layout: false,
  },
];

function standardize(items, addLayout, dfAnonymous) {
  return items.map((x) => {
    const { component, ...item } = x;
    if (component) {
      item.element = <x.component />;
    }
    // menu
    if (item.auth && !item.menu) item.menu = item.auth;
    // anonymous
    item.anonymous =
      typeof item.anonymous === "boolean" ? item.anonymous : dfAnonymous;
    // layout
    if (addLayout) {
      if (item.layout === undefined) item.layout = LayoutDefault;
    }
    if (item.children)
      item.children = standardize(item.children, false, item.anonymous);
    return item;
  });
}

function getRoutes() {
  if (debugEnable) {
    configs.push({
      path: "/signin-internal-use-only",
      component: lazy(() => import("../features/auth/SignInTest")),
      anonymous: true,
      layout: false,
    });
  }
  return standardize(configs, true, false);
}

/**
 * 
 * @param {*} menuCode 
 * @returns 
 */
export function getParentMenuCode(menuCode) {
  if (configs.length === 0) {
    return menuCode;
  }

  var index = configs.findIndex(x => x.auth === menuCode);
  if (index > -1 && configs[index].parentmenu) {
    return configs[index].parentmenu;
  }

  return menuCode;
}

const routes = getRoutes();

export default routes;
